export default __webpack_public_path__ + "static/media/21.5ce3e5a5.jpg";